import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { HHInput } from './fields';
import { FORM_NAME } from '../forms/formConstant';
import { signIn } from '../actions';

const formikEnhancer = withFormik({
  enableReinitialize: true,
  validationSchema: ({ translate, user }) => {
    const validationShape = {
      email: Yup.string()
        .email(translate('form.error.string.email'))
        .required(translate('form.error.mixed.required'))
    };

    if (!user.thirdPartyFrom) {
      validationShape.password = Yup.string()
        .max(32, translate('form.error.string.max'))
        .required(translate('form.error.mixed.required'));
    }

    return Yup.object().shape(validationShape);
  },
  mapPropsToValues: ({ user }) => ({
    email: user.thirdPartyEmail || '',
    password: ''
  }),
  handleSubmit: (values, { props, setSubmitting }) => {
    // TODO refactor callback with signInFailed var
    // refactor actions and reducers by
    // seperating them into multiple files and use of Promise see example in rekit
    // be aware of how to handle the logic flow

    const formData = { ...values };
    if (props.user.thirdPartyIdentification && props.user.thirdPartyFrom) {
      formData.thirdPartyType = props.user.thirdPartyFrom;
      formData.thirdPartyIdentification = props.user.thirdPartyIdentification;
    }

    props.signIn(formData).then(signInFailed => {
      if (signInFailed) setSubmitting(false);
    });
  },
  displayName: FORM_NAME.LOGIN_FORM
});

const LoginForm = ({
  handleSubmit, isSubmitting, translate
}) => (
  <Form inverted onSubmit={handleSubmit} >
    <div className='loginFormTitle'>
      {translate('form.title.loginUser')}
    </div>
    <Form.Field>
      <Field
        name='email'
        component={HHInput}
        otherProps={{
          id: 'email',
          className: 'g-rounded',
          placeholder: translate('form.placeholder.email'),
          type: 'email',
          allowPressEnter: 1
        }}
      />
    </Form.Field>
    <Form.Field>
      <Field
        name='password'
        component={HHInput}
        otherProps={{
          id: 'password',
          className: 'g-rounded',
          placeholder: translate('form.placeholder.password'),
          type: 'password',
          allowPressEnter: 1
        }}
      />
    </Form.Field>
    <Button
      fluid
      primary
      disabled={isSubmitting}
      loading={isSubmitting}
      className='g-rounded g-gradient'
      type='submit'
      size='medium'
    >
      {translate('form.submitBtn.login')}
    </Button>
  </Form>
);

export default compose(
  withLocalize,
  connect(({ user }) => ({ user }), { signIn }),
  formikEnhancer
)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/forms/loginForm.js